import { render } from "./Login.page.vue?vue&type=template&id=4d45c37a&scoped=true&ts=true"
import script from "./Login.page.vue?vue&type=script&lang=ts"
export * from "./Login.page.vue?vue&type=script&lang=ts"

import "./Login.page.vue?vue&type=style&index=0&id=4d45c37a&lang=scss&scoped=true"

import exportComponent from "/builds/anisen/datamanagerweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d45c37a"]])

export default __exports__